import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import { useGeneralContext } from "../../General/Context";

export default function ModalWebDocOnline({
  show,
  close,
  submit,
  docOnlineService
}) {
  const [langs, setLangs] = useState([]);
  let [langId, setLangId] = useState();
  const [errors, setErrors] = useState({});
  const [companies, setCompanies] = useState([]);
  const [companyId, setcompanyId] = useState();
  const { userInformation } = useGeneralContext();
  let { t } = useTranslation();

  useEffect(() => {
    docOnlineService.getVitaeLanguages().then((data) => {
      setLangs(data);
      docOnlineService
        .getAllCompaniesWebDocs()
        .then((data) => setCompanies(data));
    });

    if (companies.map((x) => x.companyId).includes(userInformation.companyAbbreviation) || companyId === undefined){
      setcompanyId(userInformation.companyAbbreviation);
    }
  }, []);

  function onChangeLang({ target }) {
    setLangId(target.value);
  }

  function onChangeCompany({ target }) {
    setcompanyId(target.value);
  }

  function validateAndsubmit() {
    let _errors = {};
    if (!langId) _errors.langId = t("The language is required.");
    if (!companyId) _errors.companyId = t("The company is required.");

    setErrors(_errors);
    if (Object.keys(_errors).length === 0) submit(langId, companyId);
  }

  return (
    <ModalContainer
      modalSubtitle={t("Select a Language to generate url.")}
      isOpen={show}
      submitButtonAction={validateAndsubmit}
      submitButtonTitle={t("Confirm")}
      submitButtonType="button"
      closeModal={close}
      crossmarkAction={close}
    >
      <div className="col-md-6">
        <div className="form-group">
          <div className="label-wrapper">
            <label>{t("Choose a Company")} <label className="star-style">*</label></label>
            {errors.companyId && (
              <div className="error-msg">{errors.companyId}</div>
            )}
          </div>
          <select
            id="companyId"
            name="companyId"
            className="form-select"
            onChange={onChangeCompany}
            value={companyId}
          >
            {companies.map((item) => (
              <option key={item.id} value={item.id}>
                {t(item.name)}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <div className="label-wrapper">
            <label>
              {t("Choose a language")} <label className="star-style">*</label>
            </label>
            {errors.langId && <div className="error-msg">{errors.langId}</div>}
          </div>
          <select
            id="languageId"
            name="languageId"
            className="form-select"
            onChange={onChangeLang}
            value={langId}
          >
            <option value={0} selected disabled>
              {t("Select a language...")}
            </option>
            {langs.map((item) => (
              <option key={item.id} value={item.initials}>
                {t(item.languageDescription)}
              </option>
            ))}
          </select>
        </div>
      </div>
    </ModalContainer>
  );
}
